module.exports = __webpack_public_path__ + "static/fonts/TrebuchetMS-Bold.6404140.ttf";